var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationReaded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.112,
    height: 18.14,
    viewBox: "0 0 17.112 18.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9381",
    "data-name": "Group 9381",
    transform: "translate(-420.229 -388.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M432.77,472.1l6.245,5.3H422.662l6.23-5.3C430.143,473.7,431.466,473.763,432.77,472.1Z",
    transform: "translate(-2.059 -70.791)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M426.467,441.422l-6.238,5.282V436.151Z",
    transform: "translate(0 -40.364)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M497.179,435.965v10.6l-6.257-5.3Z",
    transform: "translate(-59.838 -40.206)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M465.727,389.952H461.24a12.221,12.221,0,0,1,1.675-1.367,1.409,1.409,0,0,1,1.184.02A11.948,11.948,0,0,1,465.727,389.952Z",
    transform: "translate(-34.714 0)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M519.693,422.9l-2.1,1.773V421.14Z",
    transform: "translate(-82.417 -27.658)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M422.651,420.952v3.567l-2.1-1.766Z",
    transform: "translate(-0.273 -27.499)",
    fill: "#1baf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    d: "M449.128,402.34c0-.932-.3-1.23-1.239-1.237-1.559-.01-3.118,0-4.677,0-1.534,0-3.067-.006-4.6,0-.987,0-1.295.306-1.3,1.269-.007,1.738-.022,3.477.017,5.214a1.363,1.363,0,0,0,.417.892c1.516,1.332,3.063,2.63,4.611,3.925a1.155,1.155,0,0,0,1.765-.012c1.525-1.283,3.052-2.564,4.545-3.884a1.462,1.462,0,0,0,.442-.953C449.153,405.817,449.133,404.078,449.128,402.34Zm-2.2,5.039h-7.678a.307.307,0,1,1,0-.614h7.678a.307.307,0,1,1,0,.614Zm0-1.382h-7.678a.307.307,0,0,1,0-.614h7.678a.307.307,0,0,1,0,.614Zm0-1.382h-7.678a.307.307,0,1,1,0-.614h7.678a.307.307,0,1,1,0,.614Zm0-1.382h-7.678a.307.307,0,1,1,0-.614h7.678a.307.307,0,1,1,0,.614Z",
    transform: "translate(-14.454 -10.694)",
    fill: "#1baf2f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationReaded);
export default __webpack_public_path__ + "static/media/notification-readed.be9e6548ed529e64ac8b040261505061.svg";
export { ForwardRef as ReactComponent };